import { SkipTracingParcel } from "react-migration/domains/sites/typings/SkipTracingParcel";
import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useParcels = () => {
  const { parcels } = useSnapshot(skipTracingStore);

  return parcels as Readonly<SkipTracingParcel>[];
};
